import { render, staticRenderFns } from "./auditArea.vue?vue&type=template&id=b5a3fa8a&scoped=true&"
import script from "./auditArea.vue?vue&type=script&lang=js&"
export * from "./auditArea.vue?vue&type=script&lang=js&"
import style0 from "./auditArea.vue?vue&type=style&index=0&id=b5a3fa8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a3fa8a",
  null
  
)

export default component.exports